import api from 'api'

type AddRuleJurisdictionRequest = {
  ruleId: number
  jurisdictionId: number
}

export const addRuleJurisdiction = async (
  request: AddRuleJurisdictionRequest
): Promise<void> => {
  await api.post(`/admin/wage/rules/${request.ruleId}/jurisdictions`, {
    jurisdictionId: request.jurisdictionId,
  })
}
